import axios from "axios";

const instance = axios.create({
  // baseURL: process.env.VUE_APP_API_BASE_URL || "http://192.168.0.240:8201", // 기본 URL을 환경변수 또는 /api로 설정
  baseURL: process.env.VUE_APP_BASE_URL, // 기본 URL을 환경변수 또는 /api로 설정
  //baseURL: process.env.VUE_APP_API_BASE_URL || "http://localhost:8201", // 기본 URL을 환경변수 또는 /api로 설정
});

// JWT Interceptor
instance.interceptors.request.use(config => {
  const token = localStorage.getItem("adminToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
}, error => {
  return Promise.reject(error);
});

instance.interceptors.response.use(response => {
  return response;
}, error => {
  const status = error.response?.status;
  const requestUrl = error.config?.url || "";

  if (status === 401 && requestUrl.includes("/bx201/admin")) {
    localStorage.removeItem("adminToken");
    if (window.location.pathname !== "/login") {
      window.location.replace("/login");
    }
  }

  return Promise.reject(error);
});

export default instance;
